export const categorySpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Category',
    name: 'category',
    type: 'text',
  },
]